import { render, staticRenderFns } from "./MakerStudioView.vue?vue&type=template&id=e61c2c50&scoped=true"
import script from "./MakerStudioView.vue?vue&type=script&lang=js"
export * from "./MakerStudioView.vue?vue&type=script&lang=js"
import style0 from "./MakerStudioView.vue?vue&type=style&index=0&id=e61c2c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61c2c50",
  null
  
)

export default component.exports